import qq from 'fine-uploader/lib/core';
import * as queryString from 'qs';

require('ui-tools');
require('track-usage');

const UploadStatusBar = require('upload-status-bar');
const UploadDragAndDrop = require('upload-drag-and-drop');

if (window.UploadDragAndDrop === undefined) {
  window.UploadDragAndDrop = UploadDragAndDrop;
}

const Upload = {
  imageExtensions: ['png', 'jpg', 'jpeg'],
  documentExtensions: ['pdf', 'doc', 'docx'],
  allowedMimeTypes: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'image/*'],
  inWhiteList: (document.referrer.search('mypdfeditor.com') !== -1),
};
Upload.allowedExtensions = Upload.imageExtensions.concat(Upload.documentExtensions);

Upload.uploadLoading = (event, showOverlay = true) => {
  const $body = $('body');
  const $uploadLoaderOverlay = $('<div/>', { id: 'upload_overlay', css: { height: (window.screen.height * 2), display: showOverlay ? 'block' : 'none' } })
    .append($('<img>', { id: 'upload_loading', src: `${Upload.cdn_url}/free-write/assets/img/upload-loader.gif` }));

  if (event === 'start') {
    // Allow for us to hook-in additional events by setting a uploadStarted()
    // This is used by the Chrome Extension to perform additional actions on event start
    if (Upload.uploadStarted) {
      Upload.uploadStarted();
    }
    UploadStatusBar.updateBar('20');
    Upload.timedLoadingBarUpdates();

    $uploadLoaderOverlay.appendTo('body');
    $body.css({ overflow: 'hidden' });
    UploadStatusBar.show();
  } else if (event === 'stop') {
    // Allow for us to hook-in additional events by setting a uploadStopped
    if (Upload.uploadStopped) {
      Upload.uploadStopped();
    }

    // we have to remove this by css selector because $uploadLoaderOverlay is a different instance of this tag
    $('#upload_overlay').remove();
    $body.css({ overflow: 'auto' });
    UploadStatusBar.hide();
    UploadStatusBar.resetBar();
  }
};


Upload.getDocumentType = (responseJSON) => {
  let documentType = null;
  try {
    documentType = responseJSON.data.document.key;
  } catch (e) {
    Upload.handleError(e);
  }
  return documentType;
};

Upload.getEditLink = (documentType, path, search) => {
  const currentPath = typeof path !== 'undefined' ? path : window.location.pathname;
  const currentSearch = typeof search !== 'undefined' ? search : window.location.search;

  let url = '/free-write/edit.php?key=1&ses=1&documentType=';
  const convertPDF = (currentPath.search('convert-pdf-to-word') !== -1);
  const editPDF = (currentPath.search('edit-pdf') !== -1) || (currentPath.search('jpg-to-pdf') !== -1);
  const extensionPDF = (currentPath.search('extension/banner-upload') !== -1);
  const sem = (currentPath.search('sem') !== -1);
  const editDownload = (currentSearch.search('edit-download') !== -1) || (currentPath.search('jpg-to-pdf') !== -1);

  if (convertPDF) {
    url = '/free-write/edit-convert-doc.php?key=1&ses=1&documentType=';
  } else if (editPDF) {
    if (sem) {
      url = '/free-write/edit.php?key=1&ses=1&documentType=';
    } else if (editDownload) {
      url = '/free-write/edit-download.php?key=1&ses=1&documentType=';
    } else {
      url = '/free-write/edit.php?key=1&ses=1&documentType=';
    }
  } else if (extensionPDF) {
    url = '/free-write/edit-extension.php?key=1&ses=1&documentType=';
  }

  // Override if in whitelist
  if (Upload.inWhiteList) {
    url = '/free-write/edit-download.php?key=1&ses=1&documentType=';
  }

  return url + documentType;
};

Upload.timedLoadingBarUpdates = () => {
  setTimeout(() => { UploadStatusBar.updateBar('42'); }, 500);
  setTimeout(() => { UploadStatusBar.updateBar('46'); }, 1500);
  setTimeout(() => { UploadStatusBar.updateBar('49'); }, 1900);
  setTimeout(() => { UploadStatusBar.updateBar('52'); }, 3200);
  setTimeout(() => { UploadStatusBar.updateBar('55'); }, 4900);
  setTimeout(() => { UploadStatusBar.updateBar('58'); }, 5900);
  setTimeout(() => { UploadStatusBar.updateBar('61'); }, 7500);
  setTimeout(() => { UploadStatusBar.updateBar('65'); }, 8900);
  setTimeout(() => { UploadStatusBar.updateBar('67'); }, 9900);
  setTimeout(() => { UploadStatusBar.updateBar('69'); }, 10200);
  setTimeout(() => { UploadStatusBar.updateBar('72'); }, 12900);
  setTimeout(() => { UploadStatusBar.updateBar('74'); }, 13000);
  setTimeout(() => { UploadStatusBar.updateBar('75'); }, 15200);
  setTimeout(() => { UploadStatusBar.updateBar('76'); }, 18900);
  setTimeout(() => { UploadStatusBar.updateBar('78'); }, 19900);
  setTimeout(() => { UploadStatusBar.updateBar('80'); }, 20900);
  setTimeout(() => { UploadStatusBar.updateBar('82'); }, 22900);
  setTimeout(() => { UploadStatusBar.updateBar('84'); }, 28900);
  setTimeout(() => { UploadStatusBar.updateBar('86'); }, 33900);
  setTimeout(() => { UploadStatusBar.updateBar('89'); }, 39900);
  setTimeout(() => { UploadStatusBar.updateBar('90'); }, 45900);
  setTimeout(() => { UploadStatusBar.updateBar('92'); }, 48900);
  setTimeout(() => { UploadStatusBar.updateBar('95'); }, 58900);
  setTimeout(() => { UploadStatusBar.updateBar('97'); }, 78900);
};

Upload.addFileChangeEventsForInput = () => {
  // Remove old change events.
  $('#selectPhotos').unbind('change');
  $('#uploadPDFLarge input').unbind('change');
  $('#uploadPDFLargeMobile input').unbind('change');

  // Add event listener to our two upload buttons
  // Add Pages (Images)
  $('#selectPhotos').change((evt) => {
    Upload.photoToPDF.onFilesSelected(evt);
  });

  // Main Upload Button
  $('#uploadPDFLarge input').change((evt) => {
    // Files selected will only process uploaded images.
    Upload.photoToPDF.onFilesSelected(evt);
  });

  // Mobile Upload Button
  $('#uploadPDFLargeMobile input').change((evt) => {
    // Files selected will only process uploaded images.
    Upload.photoToPDF.onFilesSelected(evt);
  });
};

Upload.handleError = (error, message = 'Could not save uploaded file.\n\nNote: Documents larger than 100 pages are not currently supported.') => {
  if (error === 'EXPORT_ON_CREATE_ERROR') {
    window._track('Upload Error', 'Export On Create');
  }
  alert(message);
  // Since we're using multiple file upload mode to allow selecting multiple images
  // but not multiple documents, which is not something the authors of fileupload.js
  // intended, things get a bit screwy when we try to upload again after a
  // failure. Thus, lets just refresh the page after a failure. The fileupload library
  // does create a javascript alert with the error message from the server before we
  // get here so we're not just reloading the page without giving the user any kind of
  // notice.
  window.location.reload();
};

const handleOnComplete = (id, fileName, responseJSON) => {
  if (responseJSON.status === 'error') {
    Upload.handleError(responseJSON.message);
    return;
  }
  const documentType = Upload.getDocumentType(responseJSON);
  if (!documentType) {
    // We didn't get an error that the upload page sent, but we didn't get what we
    // expected either. Something went wrong
    Upload.handleError('Unknown Error', "Couldn't process upload!");
  } else {
    const redirectURL = Upload.getEditLink(documentType);

    if (window.COOKIE.get('userid') && window.COOKIE.get('userToken')) {
      window._track('Document Created', 'custom-uploaded-doc');
    }

    if (window.location !== window.parent.location) {
      window.parent.location.replace(redirectURL);
    } else {
      window.location.replace(redirectURL);
    }
  }
};

const handleFreewriteUploadSuccess = (responseJSON) => {
  let redirectURL = Upload.getEditLink(responseJSON.data.document.key);
  let documentType = '';
  redirectURL.split('&').forEach((part) => {
    const param = part.split('=');
    if (param[0] === 'documentType') {
      documentType = decodeURIComponent(param[1]);
    }
  });
  const payload = {
    user_id: window.COOKIE.get('userid'),
    user_token: window.COOKIE.get('userToken'),
    document_type: documentType,
    builder_type: 'freewrite',
    optimizely_opt_out: window.COOKIE.get('optimizelyOptOut'),
    optimizely_user_id: window.COOKIE.get('optimizelyUserId'),
  };
  window.FormSwiftAPI.createSession(payload, (response) => {
    if (response.status === 'error') {
      alert("Couldn't process upload!");
      window.ReactCompatibility.closeFreeWriteUploadLoadingModal();
      window.location.reload();
    } else {
      if (window.COOKIE.get('userid') && window.COOKIE.get('userToken')) {
        window._track('Document Created', 'custom-uploaded-doc');
      }
      const docType = documentType;
      const sessionHash = response.data.session.hash;
      const sessionKey = response.data.session.id;
      const hash = `&ses=${response.data.session.hash}`;
      const key = `&key=${response.data.session.id}`;
      documentType = `?documentType=${documentType}`;
      const freeWritePath = '/free-write/edit.php';
      redirectURL = encodeURI(window.location.origin + freeWritePath + documentType + hash + key);
      window.ReactCompatibility.closeFreeWriteUploadLoadingModal();
      window.ReactCompatibility.setFreeWriteUploadReadyRedirectURL(redirectURL, docType, sessionHash, sessionKey);
      window.ReactCompatibility.openFreeWriteUploadReadyModal();
    }
  });
};

const handleFreeWriteOnComplete = (id, fileName, responseJSON, uploadBtnID) => {
  if (responseJSON.status === 'error' || !Upload.getDocumentType(responseJSON)) {
    window.ReactCompatibility.closeFreeWriteUploadLoadingModal();
    Upload.handleError(responseJSON.message);
  } else {
    handleFreewriteUploadSuccess(responseJSON);
  }
  const uploadBtn = document.querySelector(`#${uploadBtnID} input[type="file"]`);
  if (uploadBtn) {
    uploadBtn.setAttribute('accept', Upload.allowedMimeTypes.join(', '));
    // Needed to fix input target size on Firefox
    uploadBtn.style.height = '200px';
  }
};

const handleRearrangeOnComplete = (id, fileName, responseJSON) => {
  if (responseJSON.status === 'error') {
    Upload.handleError(responseJSON.message);
  } else {
    let initialPdfLink = null;
    try {
      initialPdfLink = encodeURIComponent(responseJSON.data.document.pdf_link);
    } catch (e) {
      Upload.handleError(e);
      return;
    }

    // If uploading using uploadPDFButton.php via iFrame,
    // assign new location to parent window
    if (window.location !== window.parent.location) {
      window.parent.location = `/free-write/edit-pages.php?initial_pdf_link=${initialPdfLink}`;
    } else {
      window.location = `/free-write/edit-pages.php?initial_pdf_link=${initialPdfLink}`;
    }
  }
};

const handleRearrangeOptInOnComplete = (responseJSON) => {
  if (responseJSON.status === 'error') {
    Upload.handleError(responseJSON.message);
  } else {
    let uploadedDocumentData = null;
    try {
      uploadedDocumentData = responseJSON.data.document;
    } catch (e) {
      Upload.handleError(e);
      return;
    }

    window.handleRearrangeOptIn(uploadedDocumentData);
  }
};

const handleAddOnComplete = (id, fileName, responseJSON) => {
  if (responseJSON.status === 'error') {
    Upload.handleError(responseJSON.message);
  } else {
    window.ReactCompatibility.editPDFPagesSetPagesFromFile(responseJSON.data.document.pdf_link);
  }
};

const handleCustomTemplateOnComplete = (responseJSON) => {
  let redirectPath;
  if (responseJSON.status === 'error') {
    Upload.handleError(responseJSON.message);
    return;
  }

  // Handle IE pathname
  let currentPath = window.location.pathname;
  const customTemplateData = responseJSON.data.custom_template;
  const documentType = customTemplateData.document_type;

  currentPath = currentPath.replace('/', '');
  if (currentPath === 'sem/edit-pdf' && !(window.COOKIE.get('userid') && window.COOKIE.get('userToken'))) {
    const queryParams = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
    const redirectQueryParams = {
      ...queryParams,
      documentType,
      document_name: customTemplateData.name,
    };
    redirectPath = `/newAccount-Template?${queryString.stringify(redirectQueryParams)}`;
  } else {
    redirectPath = `/self-serve-builder?documentType=${documentType}`;
  }
  window.location.assign(redirectPath);
};

const handleESignOnComplete = (responseJSON, redirectPage) => {
  if (responseJSON.status === 'error') {
    Upload.handleError(responseJSON.message);
    return;
  }
  const documentType = Upload.getDocumentType(responseJSON);
  if (!documentType) {
    // We didn't get an error that the upload page sent, but we didn't get what we
    // expected either. Something went wrong
    Upload.handleError('Unknown Error', "Couldn't process upload!");
  } else {
    const redirectURL = `/free-write/${redirectPage}.php?documentType=${documentType}`;
    window.location.replace(redirectURL);
  }
};

Upload.getUserParams = () => {
  const formParams = {};
  const userId = window.COOKIE.get('userid');
  const userToken = window.COOKIE.get('userToken');
  if (userId) {
    formParams.creator_user_id = userId;
    formParams.creator_user_token = userToken;
  }

  return formParams;
};

Upload.activateUploadButtonById = (
  uploadBtnID,
  uploadType = 'regular',
  endpoint = '/free-write/scripts/upload_pdf.php',
  showOverlay = true,
  allowedMimeTypes = null,
  initiateUploadFromSidebarSiteNav = null,
  ) => {
  Upload.type = uploadType;
  UploadDragAndDrop.initialize(endpoint, initiateUploadFromSidebarSiteNav);
  if (Upload.photoToPDF) {
    Upload.photoToPDF.url = endpoint;
  }

  let formParams = {};
  if (uploadType === 'custom-template') {
    formParams = Upload.getUserParams();
  }

  // If the input already exists, let's remove it so it can be replaced
  let uploadBtn = document.querySelector(`#${uploadBtnID} input[type="file"]`);
  if (uploadBtn) {
    uploadBtn.remove();
  }

  const uploaderFile = new qq.FineUploaderBasic({
    button: document.getElementById(uploadBtnID),
    request: {
      params: formParams,
      inputName: 'filedata',
      requireSuccessJson: false,
      endpoint,
    },
    validation: {
      allowedExtensions: Upload.allowedExtensions,
      sizeLimit: 30485760, // 30Mb
    },
    multiple: true,
    callbacks: {
      onSubmit(id) {
        const extension = uploaderFile.getFile(0).name.split('.').pop();

        // Upload only one Document, even if multiple are selected
        if ($.inArray(extension.toLowerCase(), Upload.documentExtensions) !== -1) {
          if (Upload.type === 'freewrite') {
            window.ReactCompatibility.openFreeWriteUploadLoadingModal();
            return true;
          } else if (id === 0) {
            if (uploadType !== 'add') {
              // For split test https://app.optimizely.com/v2/projects/48120048/experiments/11944892507
              if (uploadType === 'rearrangeOptIn') {
                window.handleRearrangeOptInUploadStart();
              } else if (initiateUploadFromSidebarSiteNav) {
                initiateUploadFromSidebarSiteNav();
              } else {
                Upload.uploadLoading('start', showOverlay);
              }
            }
            return true;
          }
        }
        return false;
      },
      onError(id, name, errorReason) {
        if (errorReason.includes('XHR')) {
          // in this case, for some reason the error still gets picked up by the error handling in
          // onComplete so we don't need to do anything here
          return;
        }
        Upload.handleError('Error from Upload library', errorReason);
      },
      onComplete(id, fileName, responseJSON) {
        if (Upload.type === 'freewrite') {
          handleFreeWriteOnComplete(id, fileName, responseJSON, uploadBtnID);
        } else if (Upload.type === 'rearrange') {
          handleRearrangeOnComplete(id, fileName, responseJSON, uploadBtnID);
        } else if (uploadType === 'add') {
          handleAddOnComplete(id, fileName, responseJSON);
        } else if (uploadType === 'custom-template') {
          handleCustomTemplateOnComplete(responseJSON);
        } else if (uploadType === 'rearrangeOptIn') {
          // For split test https://app.optimizely.com/v2/projects/48120048/experiments/11944892507
          handleRearrangeOptInOnComplete(responseJSON);
        } else if (uploadType === 'edit-request-signature') {
          handleESignOnComplete(responseJSON, 'edit-request-signature');
        } else if (uploadType === 'edit-sign') {
          handleESignOnComplete(responseJSON, 'edit-sign');
        } else {
          handleOnComplete(id, fileName, responseJSON);
        }
      },
    },
  });
  uploadBtn = document.querySelector(`#${uploadBtnID} input[type="file"]`);
  if (uploadBtn) {
    // Only set accepted MIME types for non-IOS devices (to get around IOS upload bug)
    if (!UploadDragAndDrop.isIOSDevice()) {
      uploadBtn.setAttribute('accept', (allowedMimeTypes || Upload.allowedMimeTypes).join(', '));
    }
    // Needed to fix input target size on Firefox
    uploadBtn.style.height = '200px';

    // Reset the file upload event
    Upload.addFileChangeEventsForInput();
  }
};

Upload.resetUploadDestination = (e, destination) => {
  const selectFreewriteButton = document.querySelector('.edit-pages-radio-button-outer.free-write');
  const selectRearrangePagesButton = document.querySelector('.edit-pages-radio-button-outer.rearrange');
  let activeButton;

  // Remove jQuery event hanlders set by drag-and-drop
  // script and remove original upload wrapper from DOM
  window.$('.upload-wrap').off();

  // Set state of radio buttons
  const radioButtons = document.querySelectorAll('.edit-pages-radio-button-outer');

  for (let i = 0; i < radioButtons.length; i += 1) {
    radioButtons[i].classList.remove('active');
  }

  switch (destination) {
    case 'rearrange':
      window.Upload.activateUploadButtonById('uploadPDFLarge', 'rearrange', `${window.API_URL}/temporary-document`);
      window.Upload.type = 'rearrange';
      activeButton = selectRearrangePagesButton;
      break;
    case 'free-write':
      window.Upload.activateUploadButtonById('uploadPDFLarge');
      activeButton = selectFreewriteButton;
      break;
    default:
      break;
  }

  window.Upload.photoToPDF.init();
  activeButton.classList.add('active');
};

module.exports = Upload;



// WEBPACK FOOTER //
// ./src-assets/js/upload.js